module.exports = __webpack_public_path__ + "9198b58cadee503bdc854621c60e7015.png";